export default class GlscsomagpontClass {

    constructor() {
        this.glsMap = null;
        this.daynamesEnHu = {
            "friday": "péntek",
            "monday": "hétfő",
            "thursday": "csütörtök",
            "tuesday": "kedd",
            "wednesday": "szerda",
            "saturday": "szombat",
            "sunday": "vasárnap"
        };
        this.daynamesPoz = {
            "monday": 0,
            "tuesday": 1,
            "wednesday": 2,
            "thursday": 3,
            "friday": 4,
            "saturday": 5,
            "sunday": 6
        };
    }

    dpmDataConverter(data) {
        if (!data || !data.contact) {
            return null;
        }
        return {
            pclshopid: data.id,
            name: data.name,
            ctcrcode: (data.contact.countryCode || '').toLowerCase(),
            zipcode: data.contact.postalCode || data.contact.zipcode || '',
            city: data.contact.city || '',
            address: data.contact.address || '',
            contact: data.contact.name || '',
            email: data.contact.email || '',
            isparcellocker: "",
            paybybankcard: "",
            dropoffpoint: "",
            geolat: "",
            geolng: "",
            owner: "",
            iscodhandler: "",
            vendor_url: "",
            pcl_pickup_time: "",
            info: "",
            holidaystarts: null,
            holidayends: null,
            distance: "",
            openings: [],
        };
    }

    onSelectedHandler(data) {
        console.log("nyers gls:", data);

        if ($("#glsdpm").length > 0 && data != null) {
            data = this.dpmDataConverter(data);
        }

        if (data != null && data.contact && !data.zipcode) {
            data = this.dpmDataConverter(data);
        }


        if (data == null || data.name == null) {
            $('.page.szallitas .gls-valaszto-kont .gls-address').hide();
            $('.page.szallitas .gls-valaszto-kont .gls-address .address').html("");
            $('.page.szallitas .gls-valaszto-kont [name="pickup_gls_data"]').val("");
            return;
        }

        $('.page.szallitas .gls-valaszto-kont .gls-address').show();
        var addressText = data.name;
        addressText += '<br>' + data.zipcode + " " + data.city + ", " + data.address;

        if (data.phone != "" && data.phone != null) {
            addressText += '<br>Telefonszám: ' + data.phone;
        }

        if (data.openings && data.openings.length > 0) {
            var opening = [];
            for (var i = 0; i < data.openings.length; i++) {
                if (data.openings[i].open != "") {
                    opening[this.daynamesPoz[data.openings[i].day]] = this.daynamesEnHu[data.openings[i].day] + ": " + data.openings[i].open;
                }
            }
            addressText += "<div class='nyitvatartas-list'>Nyitvatartás:<br>" + opening.join('<br>') + "</div>";
        }

        $('.page.szallitas .gls-versions').addClass('d-none');
        console.log(data);

        if (
            data.pclshopid != null
            && (
                data.pclshopid.indexOf('PLOCKER') > -1
                || data.pclshopid.indexOf('PARCELL') > -1
                || data.name.indexOf('GLS Automata') > -1
            )
        ) {
            data.isparcellocker = "t";
        }

        console.log('feldolgozva:', data);

        if (data.isparcellocker == "t") {
            $('.page.szallitas .gls-versions.v1-automata').removeClass('d-none');
        } else {
            if (data.paybybankcard == "t") {
                $('.page.szallitas .gls-versions.v2-csp-kartya').removeClass('d-none');
            } else {
                $('.page.szallitas .gls-versions.v3-csp-nincskartya').removeClass('d-none');
            }
        }

        $('.page.szallitas .gls-valaszto-kont .gls-address .address').html(addressText);
        $('.page.szallitas .gls-valaszto-kont [name="pickup_gls_data"]').val(JSON.stringify(data));

        $('.page.szallitas .gls-valaszto-kont .gls-dpm gls-dpm').remove();
        $('.page.szallitas .gls-valaszto-kont .gls-dpm').addClass('d-none');
        $('.page.szallitas .gls-valaszto-kont .gls-dpm-reloadbutton').removeClass('d-none');

        // scroll to ".gls-valaszto-kont"
        if ($('.errorMSG').length == 0) {
            $('html, body').animate({
                scrollTop: $('.page.szallitas .gls-valaszto-kont').offset().top - 100
            }, 200);
        }


        var pickup_gls_data = (typeof General !== 'undefined') ? General.base64Encode(JSON.stringify(data)) : btoa(JSON.stringify(data));

        const savePromise = $.get("/index.php/webshop/savekosaratvetelgls?atvetel_helye=7&atvetel_helye_pickup_tipus=1&pickup_gls_data=" + pickup_gls_data + "&t=" + (new Date().getTime()));
        if (window.Events && window.Events.queueAtvetelRequest) {
            window.Events.queueAtvetelRequest(savePromise);
        } else {
            savePromise;
        }
    }

    mapLoaded() {
        return true;
    }

    init() {
        var self = this;

        $(function () {
            if (+$('input[name="atvetel_helye"]:checked').val() == 7) {

                $('.gls-dpm-reloadbutton a').on('click', function (e) {
                    e.preventDefault();
                    $('.gls-dpm').removeClass('d-none');
                    $('<gls-dpm></gls-dpm>').attr('country', $('.gls-dpm').data('country')).attr('id', 'glsdpm').appendTo('.gls-dpm');
                    $('.gls-dpm-reloadbutton').addClass('d-none');
                    document.getElementById("glsdpm").addEventListener('change', function (e) {
                        console.log("gls change");
                        window.Glscsomagpont.onSelectedHandler(e.detail);
                    });
                });

                if (typeof glsmapSelectedAddressData !== 'undefined') {
                    var dataParsed = JSON.parse(glsmapSelectedAddressData);
                    if (dataParsed.name != null) {
                        self.onSelectedHandler(dataParsed);
                        $('.gls-dpm gls-dpm').remove();
                        $('.gls-dpm').addClass('d-none');
                        $('.gls-dpm-reloadbutton').removeClass('d-none');
                    }
                }
            }

            if ($("#glsdpm").length > 0) {
                console.log("gls change OnInit")
                document.getElementById("glsdpm").addEventListener('change', (e) => {
                    console.log("gls change")
                    self.onSelectedHandler(e.detail);
                });
            }
        });
    }

    // Globális függvény a kompatibilitás érdekében
    static getGlobalInstance() {
        return window.Glscsomagpont;
    }
}

// Globális kompatibilitás - window.glsPSMap_OnSelected_Handler
window.glsPSMap_OnSelected_Handler = function (data) {
    if (window.Glscsomagpont) {
        window.Glscsomagpont.onSelectedHandler(data);
    }
};

window.mapLoaded = function () {
    if (window.Glscsomagpont) {
        return window.Glscsomagpont.mapLoaded();
    }
    return true;
};
